export const ELECTRONIC_REGISTRATION_FEE_PAID_TO_MAX_LENGTH = 26;
export const CRM_PUSH_ALERT_MSG_FOR_NON_ACCEPTED_OFFER =
  'Are you sure you want to push this offer ?  Your customer has selected another offer.';
